import "./ToggleSwitch.css";

import React, { useEffect, useState } from "react";

import { InputToggleProps } from "./Toggle.type";
import { useSearchParams } from "react-router-dom";

function ToggleSwitch({
  label,
  onChange,
  children,
  defaultValue,
}: Partial<InputToggleProps>) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isToggled, setIsToggled] = useState(false);

  useEffect(() => {
    setIsToggled(defaultValue || false);
  }, [defaultValue, searchParams]);

  const onToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e.target.checked);
    setIsToggled(e.target.checked);
  };

  return (
    <>
      <div className="flex flex-row gap-4">
        <label className="toggle-switch">
          <input type="checkbox" checked={isToggled} onChange={onToggle} />
          <span className="switch" />
        </label>
        {label || undefined}
      </div>
      {isToggled && children}
    </>
  );
}
export default ToggleSwitch;
